import i18next from "./i18n.js";
import { reloadByUser } from "./update.js";

/**
 * Экран вместо белой страницы при ошибке отрисовки: короткое сообщение и кнопка «Обновить».
 * Используется и во внешней `ErrorBoundary`, и как `errorElement` корневого маршрута (data-router ловит ошибки
 * страниц сам и без него показал бы свой английский «Unexpected Application Error!»). Тексты через `i18next`
 * напрямую: при ошибке провайдеры могли не отрисоваться.
 */
export function CrashScreen() {
  return (
    <div className="flex min-h-dvh items-center justify-center px-4">
      <div className="w-full max-w-md rounded-card border border-line bg-white p-6 text-center shadow-card">
        <p className="text-ink">{i18next.t("update.crashed")}</p>
        <button
          type="button"
          onClick={reloadByUser}
          className="mt-4 inline-flex items-center justify-center rounded-field bg-brand px-4 py-2.5 font-medium text-white hover:bg-brand-hover"
        >
          {i18next.t("update.reload")}
        </button>
      </div>
    </div>
  );
}
